<form name="vm.form" class="c-form u-ost-xl" #mainForm="ngForm">
	<div class="c-modal c-modal--sm">
		<div mat-dialog-content class="c-modal__dialog">
			<div class="c-modal__header">
				<div class="o-grid">
					<div class="o-grid__cell u-no-p"></div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
							<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
							<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
						</button>
					</div>
				</div>
			</div>
			<div class="c-modal__content u-no-pt">
				<div class="c-card c-card--height-fit" style="box-shadow:none;">
					<p class="c-text u-ost-xl">{{ 'Pharmacy_Redirect.Consents_Reason' | translate }}</p>
					<div class="u-ost-md u-osb-lg" *ngIf="!vm.processing">
						<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && sharing.invalid }">
							<label class="c-checkbox">
								<input type="checkbox" [(ngModel)]="vm.consents.pharmacyDataSharingAccepted" #sharing="ngModel" name="sharing" required>
								<span id="sharingCheckboxLabel">{{ 'Pharmacy_Redirect.Consent_Data_Sharing' | translate }}</span>
							</label>
						</div>
						<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && processing.invalid }">
							<label class="c-checkbox">
								<input type="checkbox" [(ngModel)]="vm.consents.pharmacyDataProcessingAccepted" name="processing" #processing="ngModel" required>
								<span id="dataProcessingCheckboxLabel">{{ 'Pharmacy_Redirect.Consent_Data_Processing' | translate }}</span>
							</label>
						</div>
					</div>
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
							<button id="pharmacyConsentsSubmitButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.submit(mainForm)" [disabled]="vm.processing || !vm.initialized">{{ 'Pharmacy_Redirect.Accept' | translate }}</button>
						</div>
					</div>
					<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
				</div>
			</div>
		</div>
	</div>
</form>